import { render } from "./PaymentsSettlement.vue?vue&type=template&id=195a933b&scoped=true"
import script from "./PaymentsSettlement.vue?vue&type=script&lang=js"
export * from "./PaymentsSettlement.vue?vue&type=script&lang=js"

import "./PaymentsSettlement.vue?vue&type=style&index=0&id=195a933b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195a933b"]])

export default __exports__